const CKEDITOR_TOOLBAR = [
  { name: "document", items: ["Source"] },
  { name: "styles", items: ["Format"] },
  {
    name: "basicstyles",
    items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat"],
  },
  { name: "paragraph", items: ["NumberedList", "BulletedList"] },
  { name: "links", items: ["Link", "Unlink"] },
  { name: "insert", items: ["Image", "Table", "HorizontalRule"] },
];

function sprintInitCkeditorTextareas(root = document) {
  if (typeof CKEDITOR === "undefined") {
    return;
  }

  CKEDITOR.config.versionCheck = false;

  root.querySelectorAll("textarea.ck-editor-field, textarea.ckeditor").forEach((textarea) => {
    if (!textarea.id) {
      return;
    }
    if (CKEDITOR.instances[textarea.id]) {
      return;
    }
    try {
      CKEDITOR.replace(textarea, {
        versionCheck: false,
        toolbar: CKEDITOR_TOOLBAR,
        extraPlugins: "image2",
        removePlugins: "image",
        resize_enabled: false,
        allowedContent: true,
      });
    } catch {
      // Already replaced or invalid element state
    }
  });
}

document.addEventListener("turbo:before-cache", () => {
  if (typeof CKEDITOR === "undefined") {
    return;
  }

  Object.keys(CKEDITOR.instances).forEach((key) => {
    try {
      CKEDITOR.instances[key].destroy();
    } catch {
      // Partially-initialized or already-destroyed instance
    }
  });
});

function sprintCkeditorTextareasNeedInit() {
  const elements = [
    ...document.querySelectorAll("textarea.ck-editor-field, textarea.ckeditor"),
  ].filter((ta) => ta.id);
  if (elements.length === 0) {
    return false;
  }
  if (typeof CKEDITOR === "undefined") {
    return true;
  }
  return elements.some((ta) => !CKEDITOR.instances[ta.id]);
}

document.addEventListener("turbo:load", () => {
  const run = (attemptsLeft) => {
    window.requestAnimationFrame(() => {
      sprintInitCkeditorTextareas();
      if (!sprintCkeditorTextareasNeedInit() || attemptsLeft <= 0) {
        return;
      }
      setTimeout(() => run(attemptsLeft - 1), 30);
    });
  };
  run(20);
});
